import React, { useEffect, useState } from "react";
import Map from "./Map";
import { Controller, useForm } from "react-hook-form";
import CreatableSelect from "react-select/creatable";
import { areaWorkshopFilterMap } from "redux/actions/apiActions";
import { connect } from "react-redux";
import Select from "react-select";
import { setSelectedArea } from "redux/actions/cartAction";
const typeOptions = [
  { value: "Home", label: "Home" },
  { value: "Office", label: "Office" },
  { value: "Other", label: "Other" },
];
const Filter = ({
  cityFilter,
  setCityFilter,
  getWorkshopFilterMap,
  globalData,
  apiData,
  setMap,
  setSelectedArea,
  cart,
  areaWorkshopFilterMap,
}) => {
  const [filter, setFilter] = useState(0);
  const [areaOptions, setAreaOptions] = useState([]);
  const [area, setArea] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    reset,
    control,
    formState: { errors, isSubmitting },
  } = useForm();

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      background: "#fff",
      borderColor: "#0000",
      minHeight: "25x",
      fontSize: "12px",
      height: "27px",
      width: "122px",
      boxShadow: state.isFocused ? null : null,
    }),

    valueContainer: (provided, state) => ({
      ...provided,
      height: "25px",
      padding: "0 6px",
    }),

    input: (provided, state) => ({
      ...provided,
      margin: "0px",
    }),
    indicatorSeparator: (state) => ({
      display: "none",
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      height: "25px",
    }),
  };
  const handleSelectChange = (event) => {
    const selectedValue = event.target.value;
    if (selectedValue == "Nearest") {
      setFilter(0);
      let productId = JSON.parse(localStorage.getItem("product-id"));
      getWorkshopFilterMap(
        40,
        1,
        globalData.locationData?.lat,
        globalData.locationData?.lng,
        productId,
        globalData.carData?.modelId,
        "Distance"
      );
    } else if (selectedValue == "Cheapest") {
      setFilter(1);
      let productId = JSON.parse(localStorage.getItem("product-id"));
      getWorkshopFilterMap(
        40,
        1,
        globalData.locationData?.lat,
        globalData.locationData?.lng,
        productId,
        globalData.carData?.modelId,
        "Cost"
      );
    }
  };

  useEffect(() => {
    console.log(apiData.workshopFilterMap);
    if (apiData?.workshopFilterMap?.length && areaOptions?.length == 0) {
      setArea(apiData?.workshopFilterMap);
      if (cityFilter == 1) {
        const uniqueAreas = Array.from(
          new Set(apiData?.workshopFilterMap.map((data) => data.AreaName))
        ).map((areaName) => {
          const data = apiData.workshopFilterMap.find(
            (item) => item.AreaName === areaName
          );
          return { value: data.AreaId, label: areaName };
        });

        setAreaOptions(uniqueAreas);
      } else if (cityFilter == 0) {
        const data = apiData?.workshopFilterMap.filter(
          (item) => item.EmirateName === globalData.locationData.data.Emirate
        );
        if (data && data?.length) {
          areaWorkshopFilterMap(data);
          const cityWorks = Array.from(
            new Set(data.map((data) => data.AreaName))
          ).map((areaName) => {
            const data = apiData.workshopFilterMap.find(
              (item) => item.AreaName === areaName
            );
            return { value: data.AreaId, label: areaName };
          });

          setAreaOptions(cityWorks);
        }
      }
    }
  }, [apiData.workshopFilterMap]);
  //   const sortArray = (selectedName, array) => {
  //     const selectedObjects = array.filter(obj => obj.name === selectedName);
  //     const remainingObjects = array.filter(obj => obj.name !== selectedName);

  //     return [...selectedObjects, ...remainingObjects];
  // };
  const selectArea = (event) => {
    if (event && area.length) {
      setSelectedOption(event);
      // setSelectedArea(event)
      // const selectArea = sortArray(event.label, apiData?.workshopFilterMap);
      const selectArea = area.filter((data) => data.AreaName == event.label);
      areaWorkshopFilterMap(selectArea);
    } else {
      areaWorkshopFilterMap(area);
      // if (cart.workshop || cart.products.length) {
      //   getWorkshopFilterMap(
      //     40,
      //     1,
      //     globalData.locationData?.lat,
      //     globalData.locationData?.lng,
      //     cart.products[0]?.Id,
      //     globalData.carData?.modelId,
      //     "Distance"
      //   );
      //   setSelectedArea(null)
      // } else {
      //   // toast.error("Select Product First")
      // }
    }
  };
  return (
    <div className="workshop-block-island-st-2">
      <div className="workshop-block-island-st-lc ">
        {/* <strong>Location</strong> */}
        <span
          className={cityFilter == 0 ? "active-loc-ws" : ""}
          onClick={() => {
            if (cityFilter != 0) setCityFilter(0);

            const data = area.filter(
              (item) =>
                item.EmirateName === globalData.locationData.data.Emirate
            );
            if (data && data?.length) {
              areaWorkshopFilterMap(data);
              const cityWorks = Array.from(
                new Set(data.map((data) => data.AreaName))
              ).map((areaName) => {
                const data = data.find((item) => item.AreaName === areaName);
                return { value: data.AreaId, label: areaName };
              });
              setAreaOptions(cityWorks);
            }

            setSelectedOption(null);
          }}
        >
          {globalData.locationData.data.Emirate}
        </span>
        <span
          onClick={() => {
            if (cityFilter != 1) setCityFilter(1);
            areaWorkshopFilterMap(area);
            const uniqueAreas = Array.from(
              new Set(area.map((data) => data.AreaName))
            ).map((areaName) => {
              const data = area.find((item) => item.AreaName === areaName);
              return { value: data.AreaId, label: areaName };
            });
            setAreaOptions(uniqueAreas);
            areaWorkshopFilterMap(area);
            setSelectedOption(null);
          }}
          className={cityFilter == 1 ? "active-loc-ws" : ""}
        >
          Any City
        </span>
        <div className="map-view-location ml-1">
          <Select
            defaultValue={[]}
            onChange={(newValue) => {
              selectArea(newValue);
            }}
            placeholder="Select Area"
            options={areaOptions}
            styles={customStyles}
            value={selectedOption}
          />
        </div>
      </div>
      <div className="d-flex align-items-center justify-content-evenly py-1">
        <button
          className="map-view"
          onClick={() => {
            setMap(true);
          }}
        >
          <div class="relative-btn">
            <div className="progress-waves centered-waves">
              <span />
            </div>
          </div>
          <i className="fa-solid fa-location-dot" /> Map View
        </button>
      </div>
      {/* <div className="workshop-block-island-st-nrst">
        <span>
          <img src="/assets/workshop-detail/sort.svg" />
        </span>
        <select onChange={handleSelectChange}>
          <option value="Nearest">Nearest</option>
          <option value="Cheapest">Cheapest</option>
        </select>
      </div> */}
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    cart: state.cart,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    areaWorkshopFilterMap: (data) => {
      dispatch(areaWorkshopFilterMap(data));
    },
    setSelectedArea: (data) => {
      dispatch(setSelectedArea(data));
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Filter);
